(function () {
    'use strict';

    angular
        .module('welcome')
        .controller('WelcomeCtrl', WelcomeCtrl);

    function WelcomeCtrl(ApplicationService, TabService, VersionService) {
        var vm = this;
        vm.userInfo = ApplicationService.getLoginInfo();
        vm.versionInfo = VersionService.getFullVersionInfo();
        TabService.addTab('welcome');
    }
}());
